import React, { useEffect, useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  Footer,
  StyledPagination,
  TotalResults,
  TotalPrice,
  StyledTooltip,
} from 'ggx-src/order-management/order-management.component.styles'

import { SmallText } from 'ggx-componentlibrary/design/typography/typography.styles'
import { formatCurrency } from 'ggx-service/i18n/format-currency.service'

function TablePageFooter({
  total,
  currentPageNumber,
  totalPageNumber,
  onPageNavClick,
  isLoading,
  totalPrice,
}) {
  const [t] = useTranslation()
  return total > 0 ? (
    <Footer>
      <TotalResults>{t('common__results', { number: total })}</TotalResults>
      <StyledPagination
        paginationText={t('orderManagement.table.pagination', {
          currentPageNumber,
          totalPageNumber,
        })}
        currentPageNumber={currentPageNumber}
        totalPageNumber={totalPageNumber}
        onPageNavClick={onPageNavClick}
        loading={isLoading}
      />
      <StyledTooltip
        noMargin
        content={t('tooltip__cancelled_orders_excluded')}
        contentWidth="150px"
      />
      <SmallText typographyStyles="m-none mr-xs mb-xxs">
        {t('common__total')}
      </SmallText>
      <TotalPrice>{formatCurrency({ amount: totalPrice })}</TotalPrice>
    </Footer>
  ) : null
}

TablePageFooter.propTypes = {
  total: PropTypes.number.isRequired,
  currentPageNumber: PropTypes.number,
  totalPageNumber: PropTypes.number,
  onPageNavClick: PropTypes.func,
  isLoading: PropTypes.number,
  totalPrice: PropTypes.number,
}

export default TablePageFooter
